import { euro } from "../geld";
import type { Warenkorbzeile } from "./warenkorb";
import { zwischensummeCent } from "./warenkorb";

interface Props {
  warenkorb: Warenkorbzeile[];
  onWeglassenUmschalten: (schluessel: string, zutat: string) => void;
  onEntfernen: (schluessel: string) => void;
}

/** Der Warenkorb: je Zeile die Speise, ihre Zutaten zum kostenlosen Weglassen und ein Entfernen. */
export function WarenkorbListe({ warenkorb, onWeglassenUmschalten, onEntfernen }: Props) {
  if (warenkorb.length === 0) {
    return <p className="hinweis">Der Warenkorb ist leer. Wähle etwas von der Speisekarte.</p>;
  }

  return (
    <div className="warenkorb">
      <ul className="warenkorb-liste">
        {warenkorb.map((zeile) => (
          <li key={zeile.schluessel} className="warenkorb-zeile">
            <div className="warenkorb-kopf">
              <span className="speise-name">{zeile.speise.name}</span>
              <span className="speise-preis">{euro(zeile.speise.stueckpreisCent)}</span>
              <button
                type="button"
                className="knopf gefahr klein"
                onClick={() => onEntfernen(zeile.schluessel)}
              >
                Entfernen
              </button>
            </div>
            {zeile.speise.zutaten.length > 0 && (
              <fieldset className="weglassen">
                <legend>Zutaten weglassen (kostenlos)</legend>
                {zeile.speise.zutaten.map((zutat) => (
                  <label key={zutat.name} className="weglassen-option">
                    <input
                      type="checkbox"
                      checked={zeile.weglassen.includes(zutat.name)}
                      onChange={() => onWeglassenUmschalten(zeile.schluessel, zutat.name)}
                    />
                    {zutat.name}
                    {zutat.ausverkauft && <span className="ausverkauft"> (ausverkauft)</span>}
                  </label>
                ))}
              </fieldset>
            )}
          </li>
        ))}
      </ul>
      <p className="zwischensumme">
        Zwischensumme: <strong>{euro(zwischensummeCent(warenkorb))}</strong>
        <span className="zart"> (zzgl. Liefergebühr bei Lieferung)</span>
      </p>
    </div>
  );
}
